import {Locale, format, parse, parseISO} from 'date-fns';
import {de} from 'date-fns/locale/de';

interface Props {
  date: string | Date | null | undefined;
  formatIn?: string | null | undefined;
  formatOut?: string | null | undefined;
  locale?: Locale | null | undefined;
}

export function EvDateFns(props: Props) {
  if (props.date === null || props.date === undefined) {
    return null;
  }

  const date = (typeof props.date === 'string') ?
    props.formatIn === 'iso' ? parseISO(props.date) :
    parse(props.date, props.formatIn ?? 'dd.MM.yyyy', null, {locale: props.locale ?? de}) :
    props.date as Date;
  return <>{format(date, props.formatOut ?? 'dd.MM.yyyy / ww', {locale: de})}</>;
}
